//View Keys
export default {
  realtimemaps_vehicletrails_trails: "Vehicle Trails",
  realtimemaps_vehicletrails_trips: "Vehicle Trips",
  realtimemaps_vehicletrails_settings: "Settings",
  realtimemaps_vehicletrails_unit: "Unit",
  realtimemaps_vehicletrails_date: "Date / Time",
  realtimemaps_vehicletrails_event: "Event",
  realtimemaps_vehicletrails_latitude: "Latitude",
  realtimemaps_vehicletrails_longitude: "Longitude",
  realtimemaps_vehicletrails_filter: "Filter",
  realtimemaps_vehicletrails_allevents: "- All Events -",
  realtimemaps_vehicletrails_gettrail: "Get Trail",
  realtimemaps_vehicletrails_gettrail_infoBubble: "Get Trail",
  realtimemaps_vehicletrails_nodata: "No data available for the requested period",
  realtimemaps_vehicletrails_closetable: "Close Vehicle Trail Table",
  realtimemaps_vehicletrails_closesettings: "Close Vehicle Trail Settings",
  realtimemaps_vehicletrails_vehicletrail_table: "View Vehicle Trail Table",
  realtimemaps_vehicletrails_vehicletrail_view: "Vehicle Trail Table",
  realtimemaps_vehicletrails_vehicletrail_err: "Loading issue has occurred. Please try again.",
  realtimemaps_vehicletrails_vehicletrail_validatedate: "The date range can not exceed 30 days",
  realtimemaps_vehicletrails_vehicletrail_validateunit: "The Unit is a mandatory field",
  realtimemaps_vehicletrails_no_activity_dates: "No activity dates",
  realtimemaps_vehicletrails_no_trips: "No trips",
  realtimemaps_vehicletrails_trip_hrs: "hrs",
  realtimemaps_vehicletrails_trip_mins: "mins",
  realtimemaps_vehicletrails_trip_miles: "miles",
  realtimemaps_vehicletrails_trip_stops: "stops",
  realtimemaps_vehicletrails_trip_io_events: "IO Events",
  realtimemaps_vehicletrails_requestvideo: "Request Video",
  realtimemaps_vehicletrails_empty_state: "Click on the vehicle trail or timeline to identify the video segment of interest.",
  realtimemaps_vehicletrails_from: "From",
  realtimemaps_vehicletrails_to: "To",
  realtimemaps_vehicletrails_duration: "Duration",
  realtimemaps_vehicletrails_submit: "Submit",
  realtimemaps_vehicletrails_error_creating_clip: "This time range has already been requested previously, please select another time range.",
  realtimemaps_vehicletrails_error_creating_clip_warning: "Warning",
  realtimemaps_vehicletrails_clip_created_successfully: "The video request has been created successfully",
  realtimemaps_vehicletrails_export: "Export",
  realtimemaps_vehicletrails_export_title: "Trips",
  realtimemaps_vehicletrails_export_event_ignition_on: "Ignition On",
  realtimemaps_vehicletrails_export_event_ignition_off: "Ignition Off",
  realtimemaps_vehicletrails_export_filename: "vehicle-trips",
  realtimemaps_vehicletrails_date_prev: "Previous date",
  realtimemaps_vehicletrails_date_next: "Next date",
  // Clip request form - resolution, style, camera view
  realtimemaps_vehicletrails_cliprequest_resolution: "Resolution",
  realtimemaps_vehicletrails_cliprequest_style: "Style",
  realtimemaps_vehicletrails_cliprequest_cameraView: "Camera View",
  realtimemaps_vehicletrails_cliprequest_placeholder_resolution: "Select resolution",
  realtimemaps_vehicletrails_cliprequest_placeholder_style: "Select style",
  realtimemaps_vehicletrails_cliprequest_placeholder_cameraView: "Select view",
  realtimemaps_vehicletrails_cliprequest_resolution_sd: "SD",
  realtimemaps_vehicletrails_cliprequest_resolution_hd: "HD",
  realtimemaps_vehicletrails_cliprequest_style_road: "Road",
  realtimemaps_vehicletrails_cliprequest_style_sideBySide: "Side by side",
  realtimemaps_vehicletrails_cliprequest_style_pictureInPicture: "Picture in picture",
  realtimemaps_vehicletrails_cliprequest_style_driver: "Driver",
  realtimemaps_vehicletrails_cliprequest_style_separate: "Separate",
  realtimemaps_vehicletrails_cliprequest_cameraView_road: "Road",
  realtimemaps_vehicletrails_cliprequest_cameraView_driver: "Driver",
};